import { Emotion$1, createEmotionProps, hasOwn, require_extends, require_hoist_non_react_statics_cjs } from "./chunk-MMWOBSVS.mjs";
import { __toESM } from "./chunk-SPFPWZVF.mjs";
// node_modules/.pnpm/@emotion+react@11.11.4_@types+react@18.3.2_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.esm.js
import * as ReactJSXRuntime from "react/jsx-runtime";
import "react";
var import_extends = __toESM(require_extends());
var import_hoist_non_react_statics = __toESM(require_hoist_non_react_statics_cjs());
function jsx2(type, props, key) {
    if (!hasOwn.call(props, "css")) {
        return ReactJSXRuntime.jsx(type, props, key);
    }
    return ReactJSXRuntime.jsx(Emotion$1, createEmotionProps(type, props), key);
}
function jsxs2(type, props, key) {
    if (!hasOwn.call(props, "css")) {
        return ReactJSXRuntime.jsxs(type, props, key);
    }
    return ReactJSXRuntime.jsxs(Emotion$1, createEmotionProps(type, props), key);
}
export { jsx2 as jsx, jsxs2 as jsxs };
